<template>
  <div class="year-report">
    <div class="yinyue-bg" @click="startOrPause" v-if="!isPause">
      <img
        class="yinyue"
        :class="{ isBegin: !isPause }"
        src="../../assets/yearReport/yinyue@2x.png"
      />
    </div>
    <div class="yinyue-pause" @click="startOrPause" v-if="isPause"></div>

    <audio
      loop
      id="music"
      :src="'https://h5.hunteron.com/music/yearnewbg.mp3'"
    ></audio>

    <div class="first-page-one" v-if="!isLast && !startReport">
      <div class="year-report-page page1 clearfix">
        <div class="year-with-border"></div>
        <div class="year-report-title"></div>
        <div class="user-avatar mt25ml31">
          <div class="img-content">
            <img
              :src="reportData.avatar | avatar('yearReport')"
              img-error-year
            />
          </div>
          <span class="name">{{ reportData.userName }}</span>
        </div>
        <div class="content flip-left-in animate-t">
          <div class="leftTopRadius"></div>
          <div class="rightBottomRadius"></div>
          <div class="desc">
            <p>时间过得好快啊</p>
            <p>{{ reportData.registrationTime || 0 }}个日夜，感谢一路相伴</p>
            <p>这里是我为你准备的“2021年度报告”</p>
            <p>请查收～</p>
          </div>
        </div>
        <div class="agree-info" v-if="isShowAgree && !isShare">
          <van-checkbox
            checked-color="transparent"
            v-model="isAgree"
            shape="square"
            >同意猎上使用你的平台数据生成你的2021年度报告</van-checkbox
          >
        </div>
      </div>
    </div>

    <van-swipe
      style="height: 100%"
      ref="swipe"
      vertical
      :show-indicators="false"
      :loop="false"
      @change="onChange"
      v-if="startReport || isLast"
    >
      <!-- <van-swipe-item v-if="!isLast">
        <div class="year-report-page page1 clearfix">
          <div class="year-with-border"></div>
          <div class="year-report-title"></div>
          <div class="user-avatar mt25ml31">
            <div class="img-content">
              <img
                :src="reportData.avatar | avatar('yearReport')"
                img-error-year
              />
            </div>
            <span class="name">{{ reportData.userName }}</span>
          </div>
          <div class="content flip-left-in animate-t">
            <div class="leftTopRadius"></div>
            <div class="rightBottomRadius"></div>
            <div class="desc">
              <p>时间过得好快啊</p>
              <p>{{ reportData.registrationTime || 0 }}个日夜，感谢一路相伴</p>
              <p>这里是我为你准备的“2021年度报告”</p>
              <p>请查收～</p>
            </div>
          </div>
          <div class="agree-info" v-if="isShowAgree && !isShare">
            <van-checkbox
              checked-color="transparent"
              v-model="isAgree"
              shape="square"
              >同意猎上使用你的平台数据生成你的2021年度报告</van-checkbox
            >
          </div>
        </div>
      </van-swipe-item> -->
      <van-swipe-item v-if="!isLast">
        <div class="year-report-page page2 clearfix">
          <div class="user-avatar mt25ml31">
            <div class="img-content">
              <img
                :src="reportData.avatar | avatar('yearReport')"
                img-error-year
              />
            </div>
            <span class="name">{{ reportData.userName }}</span>
          </div>
          <div class="thanks1 fade-right-in animate-t"></div>
          <div class="year-no-border-content">
            <div class="year-no-border"></div>
          </div>
          <div class="data1 fade-up-in animate-t">
            <p>
              这一年你在猎上网，耕耘了<span class="num">{{
                reportData.activeHours || 0
              }}</span
              >个小时，接
            </p>
            <p>
              单了<span class="num">{{
                reportData.receiveOrderCount || 0
              }}</span
              >个职位，上传了<span class="num">{{
                reportData.uploadResumeCount || 0
              }}</span
              >份简历...
            </p>
            <p class="mt30">
              这一年你尝试使用AI复推功能<span class="num">{{
                reportData.aiRepeatRecommendationCount || 0
              }}</span
              >次，使用
            </p>
            <p>
              PA派单功能<span class="num">{{
                reportData.paDispatchCount || 0
              }}</span
              >次，其中成单<span class="num">{{
                reportData.aiPaOfferCount || 0
              }}</span
              >个...
            </p>
            <p class="mt30">所有的努力和尝试都将成就更好的自己...</p>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item v-if="!isLast">
        <div class="year-report-page page3 clearfix">
          <div class="user-avatar mt25ml31">
            <div class="img-content">
              <img
                :src="reportData.avatar | avatar('yearReport')"
                img-error-year
              />
            </div>
            <span class="name">{{ reportData.userName }}</span>
            <div class="year-no-border1"></div>
          </div>
          <div class="data-content">
            <div class="mt27 fade-right-in animate-t">
              <p>
                您在猎上推荐了<span class="num">{{
                  reportData.candidateCount || 0
                }}</span
                >个候选人
              </p>
              <p>
                打败了<span class="num"
                  >{{ reportData.candidateRate | toPercentNew(1) }}%</span
                >的小伙伴
              </p>
            </div>
            <div class="mt49 fade-left-in animate-t">
              <p>
                有<span class="num">{{
                  reportData.interviewEndCount || 0
                }}</span
                >个候选人完成了面试
              </p>
              <p>
                打败了<span class="num"
                  >{{ reportData.interviewRate | toPercentNew(1) }}%</span
                >的小伙伴
              </p>
            </div>
            <div class="mt45 fade-right-in animate-t">
              <p>
                有<span class="num">{{ reportData.offerCount || 0 }}</span
                >个候选人拿到了 Offer
              </p>
              <p>
                打败了<span class="num"
                  >{{ reportData.offerRate | toPercentNew(1) }}%</span
                >的小伙伴
              </p>
            </div>
            <div class="mt45 fade-left-in animate-t">
              <p>
                有<span class="num">{{ reportData.onboardCount || 0 }}</span
                >个候选人到岗
              </p>
              <p>
                打败了<span class="num"
                  >{{ reportData.onboardRate | toPercentNew(1) }}%</span
                >的小伙伴
              </p>
            </div>
            <div class="mt45 fade-right-in animate-t">
              <p>
                有<span class="num">{{
                  reportData.overGuaranteeCount || 0
                }}</span
                >个候选人顺利过保
              </p>
              <p>
                打败了<span class="num"
                  >{{ reportData.overGuaranteeRate | toPercentNew(1) }}%</span
                >的小伙伴
              </p>
              <div class="wave"></div>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item v-if="reportData.receiveOrderCount && !isLast">
        <div class="year-report-page page4 clearfix">
          <div class="user-avatar mt25ml31">
            <div class="img-content">
              <img
                :src="reportData.avatar | avatar('yearReport')"
                img-error-year
              />
            </div>
            <span class="name">{{ reportData.userName }}</span>
          </div>
          <div class="data2 fade-left-in animate-t">
            <div class="year-no-border"></div>
            <p>
              这一年，你在猎上成了<span class="num">{{
                reportData.placementCount || 0
              }}</span
              >单，预计佣金
            </p>
            <p>
              <span class="num">{{
                (reportData.placementAmount || 0) | currency
              }}</span
              >元....
            </p>
            <p class="mt20">
              这一年，你在猎上有<span class="num">{{
                reportData.payBackCount || 0
              }}</span
              >个订单回款了，预
            </p>
            <p>
              计盈利<span class="num">{{
                (reportData.payAmount || 0) | currency
              }}</span
              >元...
            </p>
            <!-- todo -->
            <p class="mt20">
              这一年，猎上最优秀的顾问成了<span class="num">{{
                reportData.bestGetOffer || 0
              }}</span
              >单，
            </p>
            <p>
              预计佣金<span class="num">{{
                reportData.bestPlacementAmount | currency
              }}</span
              >元...
            </p>
            <p class="mt20">2022，来猎上挑战他吧...</p>
          </div>
          <div class="thanks2 fade-up-in animate-t"></div>
        </div>
      </van-swipe-item>
      <van-swipe-item v-if="reportData.receiveOrderCount && !isLast">
        <div class="year-report-page page5 clearfix">
          <div class="user-avatar mt25ml31">
            <div class="img-content">
              <img
                :src="reportData.avatar | avatar('yearReport')"
                img-error-year
              />
            </div>
            <span class="name">{{ reportData.userName }}</span>
            <div class="year-no-border1"></div>
          </div>
          <div class="title1"></div>
          <div class="pk-content">
            <div class="fade-left-in animate-t">
              <div class="heart-content pk-content-title">
                <i class="heart"></i>
                你最钟爱的
              </div>
              <ul
                class="my ranking"
                v-if="
                  reportData.likeFunctionTop3 &&
                    reportData.likeFunctionTop3.length
                "
              >
                <li
                  :key="index"
                  v-for="(name, index) in reportData.likeFunctionTop3"
                >
                  <i
                    :class="{
                      jin: index == 0,
                      yin: index == 1,
                      tong: index == 2,
                    }"
                    class="jin"
                  ></i
                  >{{ name }}
                </li>
              </ul>
            </div>
            <div class="pk fade-zoom-in animate-t"></div>
            <ul
              class="plateform ranking fade-right-in animate-t"
              v-if="
                reportData.hoFunctionTop3 && reportData.hoFunctionTop3.length
              "
            >
              <div class="fire-content pk-content-title">
                <i class="fire"></i>
                猎上最火的
              </div>
              <template
                v-if="
                  reportData.hoFunctionTop3 && reportData.hoFunctionTop3.length
                "
              >
                <li
                  :key="index"
                  v-for="(name, index) in reportData.hoFunctionTop3"
                >
                  <i
                    :class="{
                      jin: index == 0,
                      yin: index == 1,
                      tong: index == 2,
                    }"
                    class="jin"
                  ></i
                  >{{ name }}
                </li>
              </template>
            </ul>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item v-if="reportData.receiveOrderCount && !isLast">
        <div class="year-report-page page6 clearfix">
          <div class="user-avatar mt25ml31">
            <div class="img-content">
              <img
                :src="reportData.avatar | avatar('yearReport')"
                img-error-year
              />
            </div>
            <span class="name">{{ reportData.userName }}</span>
            <div class="year-no-border1"></div>
          </div>
          <div class="title2"></div>
          <div class="pk-content">
            <div class="fade-left-in animate-t">
              <div class="heart-content pk-content-title">
                <i class="heart"></i>
                你最钟爱的
              </div>
              <ul
                class="my ranking"
                v-if="
                  reportData.likeEmployerTop3 &&
                    reportData.likeEmployerTop3.length
                "
              >
                <li
                  :key="index"
                  v-for="(name, index) in reportData.likeEmployerTop3"
                >
                  <i
                    :class="{
                      jin: index == 0,
                      yin: index == 1,
                      tong: index == 2,
                    }"
                    class="jin"
                  ></i
                  >{{ name }}
                </li>
              </ul>
            </div>
            <div class="pk fade-zoom-in animate-t"></div>
            <ul class="plateform ranking fade-right-in animate-t">
              <div class="fire-content pk-content-title">
                <i class="fire"></i>
                猎上最火的
              </div>
              <template
                v-if="
                  reportData.hoEmployerTop3 && reportData.hoEmployerTop3.length
                "
              >
                <li
                  :key="index"
                  v-for="(name, index) in reportData.hoEmployerTop3"
                >
                  <i
                    :class="{
                      jin: index == 0,
                      yin: index == 1,
                      tong: index == 2,
                    }"
                    class="jin"
                  ></i
                  >{{ name }}
                </li>
              </template>
            </ul>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item v-if="reportData.receiveOrderCount && !isLast">
        <div class="year-report-page page7 clearfix">
          <div class="user-avatar mt25ml31">
            <div class="img-content">
              <img
                :src="reportData.avatar | avatar('yearReport')"
                img-error-year
              />
            </div>
            <span class="name">{{ reportData.userName }}</span>
            <div class="year-no-border1"></div>
          </div>
          <div class="title3"></div>
          <div class="pk-content">
            <div class="fade-left-in animate-t">
              <div class="heart-content pk-content-title">
                <i class="heart"></i>
                你最钟爱的
              </div>
              <ul
                class="my ranking"
                v-if="reportData.likeCityTop3 && reportData.likeCityTop3.length"
              >
                <li
                  :key="index"
                  v-for="(name, index) in reportData.likeCityTop3"
                >
                  <i
                    :class="{
                      jin: index == 0,
                      yin: index == 1,
                      tong: index == 2,
                    }"
                    class="jin"
                  ></i
                  >{{ name }}
                </li>
              </ul>
            </div>
            <div class="pk fade-zoom-in animate-t"></div>
            <ul class="plateform ranking fade-right-in animate-t">
              <div class="fire-content pk-content-title">
                <i class="fire"></i>
                猎上最火的
              </div>
              <template
                v-if="reportData.hoCityTop3 && reportData.hoCityTop3.length"
              >
                <li :key="index" v-for="(name, index) in reportData.hoCityTop3">
                  <i
                    :class="{
                      jin: index == 0,
                      yin: index == 1,
                      tong: index == 2,
                    }"
                    class="jin"
                  ></i
                  >{{ name }}
                </li>
              </template>
            </ul>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item v-if="reportData.receiveOrderCount && !isLast">
        <div class="year-report-page page8 clearfix">
          <div class="user-avatar mt25ml31">
            <div class="img-content">
              <img
                :src="reportData.avatar | avatar('yearReport')"
                img-error-year
              />
            </div>
            <span class="name">{{ reportData.userName }}</span>
          </div>
          <div class="data3 fade-left-in animate-t">
            <div class="year-no-border"></div>
            <p>{{ reportData.employerFunction || "" }}的百万顾问，如何成单？</p>
            <p class="mt20">
              一周接<span class="num">{{
                reportData.oneWeekReceiveOrderCount || 0
              }}</span
              >单，一周推荐<span class="num">{{
                reportData.oneWeekCandidateCount || 0
              }}</span
              >个候选人，一
            </p>
            <p>
              周有<span class="num">{{ reportData.oneWeekInterviewCount }}</span
              >个面试，面试率为<span class="num"
                >{{ reportData.oneWeekInterviewRate | toPercentNew(1) }}%</span
              >
            </p>
          </div>
          <div class="mt24ml25 fade-right-in animate-t">
            <!-- <div class="title4"></div> -->
            <div class="title4-new">
              {{ reportData.employerFunction || "" }}成单量Top3的企业
            </div>
            <ul
              v-if="
                reportData.employerCandidateCountTop3 &&
                  reportData.employerCandidateCountTop3.length
              "
            >
              <li
                :key="index"
                v-for="(name, index) in reportData.employerCandidateCountTop3"
              >
                {{ index + 1 }}.{{ name }}
              </li>
            </ul>
          </div>
          <div class="mt39ml25 fade-left-in animate-t">
            <!-- <div class="title5"></div> -->
            <div class="title5-new">
              {{ reportData.employerFunction || "" }}成单率Top3的企业
            </div>
            <ul
              v-if="
                reportData.employerCandidateRateTop3 &&
                  reportData.employerCandidateRateTop3.length
              "
            >
              <li
                :key="index"
                v-for="(name, index) in reportData.employerCandidateRateTop3"
              >
                {{ index + 1 }}.{{ name }}
              </li>
            </ul>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="year-report-page page9 clearfix">
          <div class="light">
            <div class="top-year">
              <div class="year-with-border"></div>
              <div class="logo"></div>
            </div>
            <div class="title6"></div>
            <div class="user-avatar mt25ml31">
              <div class="img-content">
                <img
                  :src="reportData.avatar | avatar('yearReport')"
                  img-error-year
                />
              </div>
              <span class="name">{{ reportData.userName }}</span>
            </div>
            <div class="level-tag">
              <i class="fade-zoom-in animate-t" :class="getLevelTagIcon()"></i>
            </div>
            <div class="thanks3 fade-right-in animate-t">
              <p
                v-if="
                  reportData.honoraryTitle && descMap[reportData.honoraryTitle]
                "
              >
                {{ descMap[reportData.honoraryTitle].desc1 }}
              </p>
              <p
                v-if="
                  reportData.honoraryTitle && descMap[reportData.honoraryTitle]
                "
              >
                {{ descMap[reportData.honoraryTitle].desc2 }}
              </p>
            </div>
          </div>
          <div class="erweima-content fade-left-in animate-t">
            <div class="line1"></div>
            <div class="desc">
              <div class="desc-content">
                <p>
                  感谢这{{
                    reportData.registrationTime || 0
                  }}个日夜一路相伴的你，2022
                </p>
                <p>星辰大海，猎上和你一起出发</p>
              </div>
              <div class="line2">
                {{
                  isShare
                    ? "关注猎上网公众号，开启百万顾问之旅"
                    : "关注猎上网公众号，及时获取订单信息"
                }}
              </div>
            </div>
            <div class="erweima">
              <img src="../../assets/yearReport/erweima.png" />
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <div
      v-show="!isLast && !startReport && (isAgree || isShare)"
      class="start-btn-light"
      @click="startView"
    ></div>
    <div
      v-show="!isLast && !startReport && !isAgree && !isShare"
      class="start-btn-gray"
    ></div>
    <div
      @click="next"
      v-show="
        currentIndex !== 0 &&
          currentIndex !== (reportData.receiveOrderCount ? 7 : 2)
      "
      class="arrow-down"
    ></div>
    <div
      v-show="
        currentIndex === (reportData.receiveOrderCount ? 7 : 2) && !isShare
      "
      class="share-btn"
      @click="share"
    ></div>
    <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="wrapper-overlay" @click.stop>
        <div class="img-content"></div>
        <p>点击右上角将成就分享给</p>
        <p>好友或分享至朋友圈</p>
      </div>
    </van-overlay>
  </div>
</template>
<style scoped lang="scss">
.first-page-one {
  height: 100%;
}

.animate-t {
  transition-timing-function: ease-out;
  transition-duration: 0.6s;
}

.fade-right-in {
  transform: translateX(100px);
  opacity: 0;
}

.fade-right-in.animate-in {
  transform: translateX(0);
  opacity: 1;
}

.flip-left-in {
  transform: perspective(2500px) rotateY(-100deg);
  opacity: 0;
}

.flip-left-in.animate-in {
  transform: perspective(2500px) rotateY(0);
  opacity: 1;
}

.fade-up-in {
  transform: translate3d(0, 100px, 0);
  opacity: 0;
}

.fade-up-in.animate-in {
  transform: translate3d(0, 0, 0);
  opacity: 1;
}

.fade-left-in {
  transform: translateX(-100px);
  opacity: 0;
}
.fade-left-in.animate-in {
  transform: translateX(0);
  opacity: 1;
}

.fade-zoom-in {
  transform: scale(0.6);
  opacity: 0;
}
.fade-zoom-in.animate-in {
  transform: scale(1);
  opacity: 1;
}

.year-report {
  height: 100%;
  max-width: 75rem;
  margin: auto;
  overflow: hidden;
  position: relative;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  line-height: 24px;
  p {
    white-space: nowrap;
    &.normal {
      white-space: normal;
    }
  }
  .yinyue-bg {
    background: url("../../assets/yearReport/yinyuebg@2x.png") center center
      no-repeat;
    height: 30px;
    width: 30px;
    background-size: 30px 30px;
    position: fixed;
    right: 15px;
    top: 15px;
    z-index: 99;
    text-align: center;
  }
  .yinyue-pause {
    background: url("../../assets/yearReport/pause@2x.png") center center
      no-repeat;
    height: 30px;
    width: 30px;
    background-size: 30px 30px;
    position: fixed;
    right: 15px;
    top: 15px;
    z-index: 99;
    text-align: center;
  }
  @keyframes rollin {
    from {
      transform: rotateZ(0deg);
    }
    to {
      transform: rotateZ(360deg);
    }
  }
  .yinyue {
    height: 17px;
    &.isBegin {
      animation: 3s linear 1s infinite rollin;
    }
  }
  .light {
    background: url("../../assets/yearReport/light.png") center -10px no-repeat;
    height: 45rem;
    background-size: 32rem 45rem;
  }
  i.jin {
    height: 17px;
    width: 17px;
    display: inline-block;
    background: url("../../assets/yearReport/jin.png") center center no-repeat;
    background-size: contain;
  }
  i.yin {
    height: 17px;
    width: 17px;
    display: inline-block;
    background: url("../../assets/yearReport/yin.png") center center no-repeat;
    background-size: contain;
  }
  i.tong {
    height: 17px;
    width: 17px;
    display: inline-block;
    background: url("../../assets/yearReport/tong.png") center center no-repeat;
    background-size: contain;
  }
  i.heart {
    height: 13px;
    width: 16px;
    background: url("../../assets/yearReport/redheart.png") center center
      no-repeat;
    background-size: contain;
    display: inline-block;
  }
  i.fire {
    height: 16px;
    width: 15px;
    background: url("../../assets/yearReport/fire.png") center center no-repeat;
    background-size: contain;
    display: inline-block;
  }
  i.level-tag-icon {
    height: 14.5rem;
    width: 15.7rem;
    display: inline-block;
    background-size: contain;
    &.fftq {
      background: url("../../assets/yearReport/badge/fftq.png") center center
        no-repeat;
      background-size: contain;
    }
    &.fydd {
      background: url("../../assets/yearReport/badge/fydd.png") center center
        no-repeat;
      background-size: contain;
    }
    &.fyzs {
      background: url("../../assets/yearReport/badge/fyzs.png") center center
        no-repeat;
      background-size: contain;
    }
    &.gw {
      background: url("../../assets/yearReport/badge/gw.png") center center
        no-repeat;
      background-size: contain;
    }
    &.hjbf {
      background: url("../../assets/yearReport/badge/hjbf.png") center center
        no-repeat;
      background-size: contain;
    }
    &.jzzx {
      background: url("../../assets/yearReport/badge/jzzx.png") center center
        no-repeat;
      background-size: contain;
    }
    &.msnr {
      background: url("../../assets/yearReport/badge/msnr.png") center center
        no-repeat;
      background-size: contain;
    }
    &.tjdr {
      background: url("../../assets/yearReport/badge/tjdr.png") center center
        no-repeat;
      background-size: contain;
    }
    &.zjxr {
      background: url("../../assets/yearReport/badge/zjxr.png") center center
        no-repeat;
      background-size: contain;
    }
    &.zxbj {
      background: url("../../assets/yearReport/badge/zxbj.png") center center
        no-repeat;
      background-size: contain;
    }
  }
  .erweima {
    // background: url("../../assets/yearReport/erweima.png") center center
    //   no-repeat;
    // background-size: contain;
    img {
      width: 6.4rem;
      height: 6.4rem;
    }
  }
  .pk {
    height: 96px;
    background: url("../../assets/yearReport/pk.png") center center no-repeat;
    background-size: contain;
    margin: 23px 0 26px 0;
  }
  .title1 {
    background: url("../../assets/yearReport/title1.png") no-repeat;
    height: 33px;
    background-size: contain;
    margin: 23px 0 0 36px;
  }
  .title2 {
    background: url("../../assets/yearReport/title2.png") no-repeat;
    height: 33px;
    background-size: contain;
    margin: 23px 0 0 36px;
  }
  .title3 {
    background: url("../../assets/yearReport/title3.png") no-repeat;
    height: 33px;
    background-size: contain;
    margin: 23px 0 0 36px;
  }
  .title4 {
    background: url("../../assets/yearReport/title4.png") no-repeat;
    height: 33px;
    background-size: contain;
    margin-bottom: 15px;
  }
  .title4-new {
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 15px;
    position: relative;
    display: inline-block;
    &::after {
      content: "";
      width: 143px;
      height: 8px;
      position: absolute;
      bottom: -7px;
      right: 82px;
      background: #dd8431;
    }
  }
  .title5 {
    background: url("../../assets/yearReport/title5.png") no-repeat;
    height: 33px;
    background-size: contain;
    margin-bottom: 15px;
  }
  .title5-new {
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 15px;
    position: relative;
    display: inline-block;
    &::after {
      content: "";
      width: 143px;
      height: 8px;
      position: absolute;
      bottom: -7px;
      right: 82px;
      background: #dd8431;
    }
  }
  .title6 {
    background: url("../../assets/yearReport/title6.png") no-repeat;
    height: 35px;
    background-size: contain;
    margin: 13px 0 0 25px;
  }
  .mt24ml25 {
    margin: 24px 0 0 25px;
  }
  .mt39ml25 {
    margin: 39px 0 0 25px;
  }
  .arrow-down {
    width: 25px;
    height: 24.5px;
    cursor: pointer;
    background: url("../../assets/yearReport/arrowDown.png") no-repeat;
    background-size: contain;
    position: absolute;
    bottom: 25px;
    left: 50%;
    transform: translateX(-50%);
  }
  .start-btn {
    cursor: pointer;
    height: 43px;
    width: 205.5px;
    background: url("../../assets/yearReport/start-btn.png") no-repeat;
    background-size: contain;
    position: absolute;
    bottom: 49px;
    left: 50%;
    transform: translateX(-50%);
  }
  .start-btn-light {
    cursor: pointer;
    height: 43px;
    width: 205.5px;
    background: url("../../assets/yearReport/new-start-light.png") no-repeat;
    background-size: contain;
    position: absolute;
    bottom: 49px;
    left: 50%;
    transform: translateX(-50%);
  }
  .start-btn-gray {
    cursor: pointer;
    height: 43px;
    width: 205.5px;
    background: url("../../assets/yearReport/new-start-gray.png") no-repeat;
    background-size: contain;
    position: absolute;
    bottom: 49px;
    left: 50%;
    transform: translateX(-50%);
  }
  .share-btn {
    width: 205.5px;
    height: 43px;
    background: url("../../assets/yearReport/share-btn.png") no-repeat;
    background-size: contain;
    position: absolute;
    bottom: 38px;
    left: 50%;
    transform: translateX(-50%);
  }
  .pk-content {
    margin: 23px auto 0;
    width: 305px;
    .pk-content-title {
      border-radius: 5px;
      background: #fff;
      border: 1px solid #fff;
      font-size: 14px;
      font-weight: 500;
      color: #4d2701;
      display: flex;
      align-items: center;
      height: 27px;
    }
    .heart-content {
      width: 108px;
      white-space: nowrap;
      .heart {
        margin: 0 7px;
      }
    }
    .fire-content {
      width: 108px;
      white-space: nowrap;
      .fire {
        margin: -1px 6px 0 8px;
      }
    }
    .ranking {
      li {
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        &:last-child {
          margin-bottom: 0;
        }
        i {
          margin-right: 10px;
        }
      }
    }
    .my {
      margin-top: 19px;
    }
    .plateform {
      position: relative;
      .fire-content {
        margin-left: auto;
        position: absolute;
        top: -53px;
        right: 0;
      }
      li {
        flex-direction: row-reverse;
        i {
          margin: 0 0 0 10px;
        }
      }
    }
  }
  .year-report-page {
    position: relative;
    height: 100%;
    background-size: cover;
    .mt20 {
      margin-top: 20px;
    }
    .mt27 {
      margin-top: 27px;
    }
    .mt49 {
      margin-top: 49px;
    }
    .mt45 {
      margin-top: 45px;
    }
    .mt25ml31 {
      margin: 25px 0 0 31px;
    }
    .user-avatar {
      display: flex;
      align-items: center;
      .img-content {
        height: 38px;
        overflow: hidden;
        border-radius: 50%;
        margin-right: 10px;
        text-align: center;
        img {
          max-width: 100%;
          max-height: 100%;
          line-height: 38px;
        }
      }
      .name {
        font-size: 19px;
        font-weight: 400;
        color: #ffffff;
      }
    }
    .num {
      background: #ffffff;
      opacity: 0.7;
      border-radius: 4px;
      color: #000;
      padding: 2px 2px;
      margin: 0 2px;
    }
    .year-no-border1 {
      height: 25px;
      background: url("../../assets/yearReport/year-no-border.png") no-repeat;
      background-size: contain;
      width: 133px;
      margin-left: auto;
    }
  }
  .page1 {
    background: url("../../assets/yearReport/bg/1.jpg") center center no-repeat;
    background-size: cover;
    .year-with-border {
      height: 43px;
      margin: 41px 0 0 23px;
      background: url("../../assets/yearReport/year-with-border.png") no-repeat;
      background-size: contain;
    }
    .year-report-title {
      height: 42px;
      margin: 19px 0 0 23px;
      background: url("../../assets/yearReport/yeartitle.png") no-repeat;
      background-size: contain;
    }

    .content {
      width: 305px;
      margin: 66px auto 0;
      padding: 10px 5px;
      position: relative;
      .leftTopRadius {
        width: 26px;
        height: 26px;
        background: url("../../assets/yearReport/letfTopRadius.png") no-repeat;
        position: absolute;
        top: 0;
        left: 0;
        background-size: contain;
      }
      .rightBottomRadius {
        width: 26px;
        height: 26px;
        background: url("../../assets/yearReport/rightBottomRadius.png")
          no-repeat;
        position: absolute;
        right: 0;
        bottom: 0;
        background-size: contain;
      }
      .desc {
        text-align: center;
        color: #ffffff;
        font-size: 18px;
        line-height: 27px;
        font-weight: 500;
        p {
          white-space: nowrap;
        }
      }
    }
  }
  .page2 {
    background: url("../../assets/yearReport/bg/1.jpg") center center no-repeat;
    background-size: cover;
    .thanks1 {
      height: 142px;
      background: url("../../assets/yearReport/thanks1.png") no-repeat;
      background-size: contain;
      margin: 31px 0 0 31px;
    }
    .year-no-border-content {
      width: 332px;
      text-align: right;
      margin: 15px auto 6px;
    }
    .year-no-border {
      height: 34px;
      background: url("../../assets/yearReport/year-no-border.png") no-repeat;
      background-size: contain;
      width: 113px;
      display: inline-block;
    }
    .data1 {
      width: 332px;
      background: url("../../assets/yearReport/whiteborder1.png") no-repeat;
      margin: auto;
      height: 233.5px;
      background-size: contain;
      padding: 40px 18px 20px 18px;
      font-size: 15px;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      .mt30 {
        margin-top: 30px;
      }
    }
  }
  .page3 {
    background: url("../../assets/yearReport/bg/3.jpg") center center no-repeat;
    background-size: cover;
    .data-content {
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      div {
        position: relative;
        margin-left: 33px;
        .wave {
          width: 114.5px;
          height: 28px;
          background: url("../../assets/yearReport/wave.png") no-repeat;
          background-size: contain;
          margin-left: auto;
          position: absolute;
          right: 0;
          bottom: 6px;
        }
      }
    }
  }
  .page4 {
    background: url("../../assets/yearReport/bg/4.jpg") center center no-repeat;
    background-size: cover;
    .data2 {
      width: 329px;
      height: 275.5px;
      background: url("../../assets/yearReport/whiteborder2.png") no-repeat;
      background-size: contain;
      margin: 40px auto 0;
      padding: 40px 0 0 12px;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      position: relative;
      .year-no-border {
        background: url("../../assets/yearReport/year-no-border.png") no-repeat;
        height: 34px;
        background-size: contain;
        position: absolute;
        top: -44px;
        width: 113.5px;
        right: 0;
      }
    }
    .thanks2 {
      width: 307px;
      height: 48px;
      background: url("../../assets/yearReport/thanks2.png") no-repeat;
      margin: 47px auto 0;
      background-size: contain;
    }
  }
  .page5 {
    background: url("../../assets/yearReport/bg/5.jpg") center center no-repeat;
    background-size: cover;
  }
  .page6 {
    background: url("../../assets/yearReport/bg/6.jpg") center center no-repeat;
    background-size: cover;
  }
  .page7 {
    background: url("../../assets/yearReport/bg/7.jpg") center center no-repeat;
    background-size: cover;
  }
  .page8 {
    background: url("../../assets/yearReport/bg/8.jpg") center center no-repeat;
    background-size: cover;
    .data3 {
      width: 329px;
      height: 150px;
      background: url("../../assets/yearReport/whiteborder3.png") no-repeat;
      background-size: contain;
      margin: 40px auto 0;
      padding: 40px 0 0 12px;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      position: relative;
      .year-no-border {
        background: url("../../assets/yearReport/year-no-border.png") no-repeat;
        height: 34px;
        background-size: contain;
        position: absolute;
        top: -44px;
        width: 113.5px;
        right: 0;
      }
    }
  }
  .page9 {
    background: url("../../assets/yearReport/bg/9.jpg") center center no-repeat;
    background-size: cover;
    .top-year {
      padding: 4.2rem 2.5rem 0;
      display: flex;
      justify-content: space-between;
      .year-with-border {
        background: url("../../assets/yearReport/year-with-border.png")
          no-repeat;
        background-size: contain;
        height: 3.5rem;
        width: 9.2rem;
      }
      .logo {
        background: url("../../assets/yearReport/logo.png") no-repeat;
        background-size: contain;
        height: 3.3rem;
        width: 11rem;
      }
    }
    .level-tag {
      margin: 0.6rem auto 2.7rem;
      text-align: center;
      width: 32.3rem;
      background: url("../../assets/yearReport/star.png") no-repeat;
      background-size: contain;
    }
    .thanks3 {
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      width: 34.5rem;
      margin: 0 auto 2.2rem;
    }
    .erweima-content {
      background: rgba(0, 0, 0, 0.12);
      width: 34.5rem;
      position: relative;
      padding: 1.6rem 0.8rem 1rem 1rem;
      margin: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      .desc {
        .desc-content {
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          margin-bottom: 0.8rem;
          line-height: 2rem;
        }
      }
      .line1 {
        background: url("../../assets/yearReport/line1.png") no-repeat;
        background-size: contain;
        height: 0.8rem;
        position: absolute;
        top: 0;
        left: 0;
        width: 34.5rem;
      }
      .line2 {
        background: url("../../assets/yearReport/line2.png") no-repeat;
        background-size: contain;
        height: 2rem;
        font-size: 14px;
        font-weight: 500;
        color: #f7d399;
        padding-left: 0.5rem;
        line-height: 2rem;
      }
    }
  }
}
</style>
<style lang="scss">
.year-report {
  .van-checkbox__icon--checked .van-icon {
    border-color: #fff !important;
  }
  .agree-info {
    font-size: 13px;
    position: absolute;
    bottom: 109px;
    width: 323px;
    margin: auto;
    left: 50%;
    transform: translateX(-50%);
    .van-checkbox {
      justify-content: center;
      .van-checkbox__label {
        font-size: 13px;
        color: #fff;
      }
    }
  }
}

.wrapper-overlay {
  position: absolute;
  top: 10px;
  right: 30px;
  font-size: 17px;
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
  text-align: right;
  .img-content {
    height: 58px;
    width: 56px;
    background: url("../../assets/yearReport/arrow-top@2x.png") center center
      no-repeat;
    background-size: contain;
    display: inline-block;
  }
  p {
    text-align: left;
  }
}
</style>
<script>
import { retrieveYearReportData } from "@/api/yearReport";
import wx from "weixin-js-sdk";

export default {
  name: "year-report-module",
  components: {},
  data() {
    return {
      startReport: false,
      isPause: false,
      isAgree: false,
      isShowAgree: false,
      isAllowScroll: false,
      tagdesc: "",
      descMap: {
        精英顾问: {
          icon: "level-tag-icon gw",
          desc1: "行路不易，还好现在的你，",
          desc2: "才华横溢，未来可期",
        },
        面试牛人: {
          icon: "level-tag-icon msnr",
          desc1: "做足每一个细节，你就站在了成功的门前，",
          desc2: "再向前一步，你值得用于一切",
        },
        推荐达人: {
          icon: "level-tag-icon tjdr",
          desc1: "千里之行始于足下，今天种下推荐，",
          desc2: "明天收获Offer",
        },
        精准之星: {
          icon: "level-tag-icon jzzx",
          desc1: "君志所向，一往如前，",
          desc2: "愈挫愈奋，再接再厉",
        },
        最佳新人: {
          icon: "level-tag-icon zjxr",
          desc1: "积累着点点滴滴的收获，堆积成自信的高峰，",
          desc2: "浓缩着星星点点的能力，奋斗出傲人的成果",
        },
        风云大单: {
          icon: "level-tag-icon fydd",
          desc1: "命运的舵是奋斗，不抱有一丝幻想，不放弃",
          desc2: "一点机会，未来的你会感谢今天的坚持",
        },
        扶摇直上: {
          icon: "level-tag-icon fyzs",
          desc1: "当一个人静下心来，脚踏实地一步一个脚印",
          desc2: "向前走的时候，一个强大的自我就产生了",
        },
        厚积薄发: {
          icon: "level-tag-icon hjbf",
          desc1: "你受的苦、吃的亏、担的责、扛的罪到最后",
          desc2: "都会变成光，照亮你的路",
        },
        奋发图强: {
          icon: "level-tag-icon fftq",
          desc1: "虽然现在很辛苦，但是加油吧，再黑暗的隧道",
          desc2: "也有出口，光明一定就在前方",
        },
        朝夕不倦: {
          icon: "level-tag-icon zxbj",
          desc1: "阳光下灿烂，风雨中奔跑，",
          desc2: "做自己的梦，走自己的路",
        },
      },
      showOverlay: false,
      loading: false,
      isShare: this.$route.query.isShare,
      mp_token: this.$route.query.mp_token,
      isLast: this.$route.query.isLast,
      yearReportUUID: this.$route.query.yearReportUUID,
      currentIndex: 0,
      count: 1,
      reportData: {},
    };
  },
  methods: {
    startOrPause() {
      this.isPause = !this.isPause;
      let music = document.querySelector("#music");
      if (this.isPause) {
        music.pause();
      } else {
        music.play();
      }
    },
    getLevelTagIcon() {
      return this.reportData &&
        this.reportData.honoraryTitle &&
        this.descMap[this.reportData.honoraryTitle] &&
        this.descMap[this.reportData.honoraryTitle].icon
        ? this.descMap[this.reportData.honoraryTitle].icon
        : "";
    },
    onChange(index) {
      if (index == 1) {
        this.isShowAgree = false;
      }

      this.currentIndex = index;
      this.refreshAnimate();
    },
    reloadFirstAnimate() {
      let atItem = document.querySelectorAll(".van-swipe-item .animate-t");
      if (!atItem[0].classList.contains("animate-in")) {
        atItem[0].classList.add("animate-in");
      }
      atItem.forEach((at) => {
        if (!at.classList.contains("animate-in")) {
          at.classList.add("animate-in");
        }
      });
    },
    reloadFirstOneAnimate() {
      let atItem = document.querySelectorAll(".first-page-one .animate-t");
      if (atItem && atItem.length) {
        if (!atItem[0].classList.contains("animate-in")) {
          atItem[0].classList.add("animate-in");
        }
        atItem.forEach((at) => {
          if (!at.classList.contains("animate-in")) {
            at.classList.add("animate-in");
          }
        });
      }
    },
    refreshAnimate() {
      let atItem = document.querySelectorAll(".animate-t");
      atItem.forEach((at) => {
        if (at.classList.contains("animate-in")) {
          at.classList.remove("animate-in");
        }

        setTimeout(() => {
          at.classList.add("animate-in");
        }, 300);
      });
    },
    startView() {
      if (this.isShare || this.isAgree) {
        this.isShowAgree = false;
        this.isAllowScroll = true;
        this.startReport = true;

        this.$nextTick(() => {
          this.refreshAnimate();
        });
      }
    },
    next() {
      this.$refs.swipe.next();
    },
    share() {
      let link = window.location.href;
      if (!this.$route.query.yearReportUUID) {
        link = link + "?yearReportUUID=" + this.reportData.yearReportUUID;
      }

      link = link + "&isShare=true&isLast=true";

      this.$store.commit("comp/WX_SHARE", {
        title: (this.reportData.userName || "") + "的2021年度报告",
        desc: "抱利他之心，行利他之事，2021感恩有你一路相伴",
        link: link,
      });
      this.showOverlay = true;
    },
    getYearReportData() {
      retrieveYearReportData({
        yearReportUUID: this.$route.query.yearReportUUID,
      }).then((res) => {
        if (res && res.data) {
          res.data.employerCandidateCountTop3 = res.data
            .employerCandidateCountTop3
            ? res.data.employerCandidateCountTop3.split(",")
            : [];
          res.data.employerCandidateRateTop3 = res.data
            .employerCandidateRateTop3
            ? res.data.employerCandidateRateTop3.split(",")
            : [];

          res.data.hoCityTop3 = res.data.hoCityTop3
            ? res.data.hoCityTop3.split(",")
            : [];
          res.data.hoEmployerTop3 = res.data.hoEmployerTop3
            ? res.data.hoEmployerTop3.split(",")
            : [];
          res.data.hoFunctionTop3 = res.data.hoFunctionTop3
            ? res.data.hoFunctionTop3.split(",")
            : [];

          res.data.likeCityTop3 = res.data.likeCityTop3
            ? res.data.likeCityTop3.split(",")
            : [];
          res.data.likeEmployerTop3 = res.data.likeEmployerTop3
            ? res.data.likeEmployerTop3.split(",")
            : [];
          res.data.likeFunctionTop3 = res.data.likeFunctionTop3
            ? res.data.likeFunctionTop3.split(",")
            : [];

          this.reportData = res.data;
        }
        this.$nextTick(() => {
          if (this.isLast) {
            this.reloadFirstAnimate();
          }

          this.reloadFirstOneAnimate();
          let link = window.location.href;
          if (!this.$route.query.yearReportUUID) {
            link = link + "?yearReportUUID=" + this.reportData.yearReportUUID;
          }

          link = link + "&isShare=true";

          this.$store.commit("comp/WX_SHARE", {
            title: (this.reportData.userName || "") + "的2021年度报告",
            desc: "抱利他之心，行利他之事，2021感恩有你一路相伴",
            link: link,
          });
        });
      });
    },
    beginPlay() {
      let music = document.querySelector("#music");
      if (music) {
        this.isPause = true;
        music.play();
        music.addEventListener("playing", (event) => {
          this.isPause = false;
        });
        music.addEventListener("canplaythrough", (event) => {
          console.log("canplaythrough");
          this.tagdesc = "canplaythrough";
        });
      }
    },
  },
  computed: {},
  beforeDestroy() {
    let music = document.querySelector("#music");
    music.pause();
  },
  destroyed() {},
  watch: {
    isAgree(n, o) {
      if (n) {
        localStorage.setItem("m-agreeReport", 1);
      } else {
        localStorage.removeItem("m-agreeReport");
      }
    },
  },
  mounted() {
    // this.beginPlay();
  },
  created() {
    this.isAgree = !!localStorage.getItem("m-agreeReport");
    this.isShowAgree = !localStorage.getItem("m-agreeReport");
    this.isAllowScroll = !!this.$route.query.isShare;
    this.isPause = true;
    this.getYearReportData();
    // document.addEventListener("WeixinJSBridgeReady", () => {
    //   WeixinJSBridge &&
    //     WeixinJSBridge.invoke("getNetworkType", {}, () => {
    //       this.beginPlay();
    //     });
    // });
  },
};
</script>
